import { Route, Routes } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AboutPage, { routeMain as routeAboutPage } from "pages/AboutPage";
import ContactsPage, {
  routeMain as routeContactsPage,
} from "pages/ContactsPage";
import MainPage from "pages/MainPage";
import NotFoundPage, {
  routeMain as routeNotFoundPage,
} from "pages/NotFoundPage";
import ConceptPage, { routeMain as routeConceptPage } from "pages/СonceptPage";
import ProjectPage, { routeMain as routeProjectPage } from "pages/ProjectPage";
import ArchitecturePage, {
  routeMain as routeArchitecturePage,
} from "pages/ArchitecturePage";
import PrivacyPage, { routeMain as routePrivacyPage } from "pages/PrivacyPage";
import ConsentPage, { routeMain as routeConsentPage } from "pages/ConsentPage";
import CookiesInfoPage, { routeMain as routeCookiesPage } from "pages/CookiesInfoPage";

import Header from "components/Header";
import Footer from "components/Footer";
import CookieConsent from "react-cookie-consent";

import styles from "./styles.module.scss";

const AppContent = () => {
  return (
    <div className={styles.wrapper}>
      <ToastContainer
        position="top-right"
        autoClose={500000}
        limit={10}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        theme="dark"
      />
      <CookieConsent
        buttonText="Хорошо"
        cookieName="prowellness_cookie_consent"
        expires={365}
        disableStyles={true}
        containerClasses={styles.cookieConsent}
        buttonClasses={styles.cookieConsentButton}
        enableDeclineButton={true}
        declineButtonText="+"
        declineButtonClasses={styles.cookieConsentClose}
      >
        Оставаясь на сайте, вы выражаете свое согласие — <a className={styles.cookieConsentLink} href={routeConsentPage()}>Соглашение </a> на обработку персональных данных в соответствии с <a className={styles.cookieConsentLink} href={routePrivacyPage()}>Политикой в отношении обработки персональных данных</a> ООО «ПРО ВЕЛНЕС». Продолжая использовать наш сайт, вы соглашаетесь с <a className={styles.cookieConsentLink} href={routeCookiesPage()}>Политикой обработки файлов cookie </a>.
      </CookieConsent>
      <Header />
      <main className={styles.mainWrapper}>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path={routeAboutPage()} element={<AboutPage />} />
          <Route path={routeContactsPage()} element={<ContactsPage />} />
          <Route path={routeConceptPage()} element={<ConceptPage />} />
          <Route path={routeNotFoundPage()} element={<NotFoundPage />} />
          <Route path={routeProjectPage() + "/:id"} element={<ProjectPage />} />
          <Route
            path={routeArchitecturePage()}
            element={<ArchitecturePage />}
          />
          <Route path="*" element={<NotFoundPage />} />
          <Route path={routePrivacyPage()} element={<PrivacyPage />} />
          <Route path={routeConsentPage()} element={<ConsentPage />} />
          <Route path={routeCookiesPage()} element={<CookiesInfoPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default AppContent;
